import React, { useState } from 'react';
import { Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { DataProvider } from './contexts/DataContext';
import './i18n/config';
import ProtectedRoute from './components/ProtectedRoute';
import Login from './pages/Login';
import Sidebar from './components/Sidebar';
import Header from './components/Header';
import Toast from './components/Toast';
import Dashboard from './pages/Dashboard';
import Alerts from './pages/Alerts';
import Users from './pages/Users';
import Branches from './pages/Branches';
import Positions from './pages/Positions';
import Departments from './pages/Departments';
import Permissions from './pages/Permissions';
import Customers from './pages/Customers';
import CustomerGroups from './pages/CustomerGroups';
import DataSources from './pages/DataSources';
import DataUpload from './pages/DataUpload';
import DataRepository from './pages/DataRepository';
import Models from './pages/Models';
import Indicators from './pages/Indicators';
import Warnings from './pages/Warnings';
import Workflows from './pages/Workflows';
import CustomerCaseManagement from './pages/CustomerCaseManagement';
import CaseFilterRules from './pages/CaseFilterRules';
import UserProfile from './pages/UserProfile';
import ChangePassword from './pages/ChangePassword';
import SystemConfig from './pages/SystemConfig';
import ReportList from './pages/ReportList';
import ExecutiveSummaryDashboard from './pages/reports/ExecutiveSummaryDashboard';
import ExecutiveSummary from './pages/reports/ExecutiveSummary';
import ModelDistribution from './pages/reports/ModelDistribution';
import FindingOverview from './pages/reports/FindingOverview';
import SummaryReport from './pages/reports/SummaryReport';
import HighRiskReport from './pages/reports/HighRiskReport';
import MediumRiskReport from './pages/reports/MediumRiskReport';
import LowRiskReport from './pages/reports/LowRiskReport';
import ResolvedReport from './pages/reports/ResolvedReport';
import ModelsReport from './pages/reports/ModelsReport';

function App() {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [toast, setToast] = useState({ show: false, message: '', type: 'info' });

  const showToast = (message, type = 'info') => {
    setToast({ show: true, message, type });
    setTimeout(() => {
      setToast({ show: false, message: '', type: 'info' });
    }, 3000);
  };

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  return (
    <AuthProvider>
      <DataProvider>
        <Routes>
          {/* Public Route */}
          <Route path="/login" element={<Login />} />
          
          {/* Protected Routes */}
          <Route path="*" element={
            <ProtectedRoute>
              <div className="app-wrapper">
                <Sidebar isOpen={sidebarOpen} />
                <div className={`main-wrapper ${sidebarOpen ? 'sidebar-open' : 'sidebar-closed'}`}>
                  <Header toggleSidebar={toggleSidebar} sidebarOpen={sidebarOpen} showToast={showToast} />
                  <main className="page-content">
                    <Routes>
                      <Route path="/" element={<Dashboard showToast={showToast} />} />
                      <Route path="/customers" element={<Customers showToast={showToast} />} />
                      <Route path="/customer-groups" element={<CustomerGroups showToast={showToast} />} />
                      <Route path="/alerts" element={<Alerts showToast={showToast} />} />
                      <Route path="/users" element={<Users showToast={showToast} />} />
                      <Route path="/branches" element={<Branches showToast={showToast} />} />
                      <Route path="/positions" element={<Positions showToast={showToast} />} />
                      <Route path="/departments" element={<Departments showToast={showToast} />} />
                      <Route path="/permissions" element={<Permissions showToast={showToast} />} />
                      <Route path="/data-sources" element={<DataSources showToast={showToast} />} />
                      <Route path="/data-upload" element={<DataUpload showToast={showToast} />} />
                      <Route path="/data-repository" element={<DataRepository showToast={showToast} />} />
                      <Route path="/models" element={<Models showToast={showToast} />} />
                      <Route path="/indicators" element={<Indicators showToast={showToast} />} />
                      <Route path="/warnings" element={<Warnings showToast={showToast} />} />
                      <Route path="/workflows" element={<Workflows showToast={showToast} />} />
                      <Route path="/system-config" element={<SystemConfig showToast={showToast} />} />
                      <Route path="/profile" element={<UserProfile showToast={showToast} />} />
                      <Route path="/change-password" element={<ChangePassword showToast={showToast} />} />
                      <Route path="/case-management" element={<CustomerCaseManagement showToast={showToast} />} />
                      <Route path="/case-filter-rules" element={<CaseFilterRules showToast={showToast} />} />
                      <Route path="/reports" element={<ReportList />} />
                      <Route path="/reports/executive-dashboard" element={<ExecutiveSummaryDashboard />} />
                      <Route path="/reports/executive-summary" element={<ExecutiveSummary />} />
                      <Route path="/reports/model-distribution" element={<ModelDistribution />} />
                      <Route path="/reports/finding-overview" element={<FindingOverview />} />
                      <Route path="/reports/summary" element={<SummaryReport />} />
                      <Route path="/reports/high-risk" element={<HighRiskReport />} />
                      <Route path="/reports/medium-risk" element={<MediumRiskReport />} />
                      <Route path="/reports/low-risk" element={<LowRiskReport />} />
                      <Route path="/reports/resolved" element={<ResolvedReport />} />
                      <Route path="/reports/models" element={<ModelsReport />} />
                    </Routes>
                  </main>
                </div>
                <Toast {...toast} onClose={() => setToast({ ...toast, show: false })} />
              </div>
            </ProtectedRoute>
          } />
        </Routes>
      </DataProvider>
    </AuthProvider>
  );
}

export default App;
